var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-form-checkbox',{directives:[{name:"gl-tooltip",rawName:"v-gl-tooltip.right",modifiers:{"right":true}}],staticClass:"gl-w-0",attrs:{"title":_vm.tooltipText,"disabled":_vm.disabled,"checked":_vm.checked,"indeterminate":_vm.indeterminate},on:{"change":_vm.handleChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }